import React, {Component} from 'react'
import {getListBoxes, createLLCBoxes, addDiaryNextBoxes} from "../../../services/api/apiNextBox"
import TableHeadBox from "./TableHeadBox"
import CreateNewBox from "./CreateNewBox"
import ListBoxPagination from "./ListBoxPagination"
import {Link} from "react-router-dom"
import MarkAsShippedBox from "./MarkAsShippedBox"
import ImportTrackingModal from "./import/ImportTrackingModal"
import CreateNewBoxFBA from "./CreateNewBoxFBA"
import ModalEditInfoBox from "./ModalEditInfoBox"
import { Spin, DatePicker, Checkbox, message, Popover, Select, Input } from "antd"
import BoxItemContainer from "./BoxItemContainer"
import moment from 'moment'
import ExportListBoxes from "./export/ExportListBoxes"
import CustomMultiSelect from './CustomMultiSelect'
import {listLocal} from '../../helpers/filtersTable'
import Button from 'reactstrap/es/Button'
import CreateMultiBoxLLC from './CreateMultiBoxLLC'
import CreateBatchShip from './CreateBatchShip'
import BatchShipBulkAction from './BatchShipBulkAction'
import AddSizeWeightModal from './AddSizeWeightModal'
import FinishUpdateInfoModal from './FinishUpdateInfoModal'
import {Tooltip, Popconfirm} from 'antd'
import { getListShippingCarrierApp } from '../../../services/api/apiFFM'
import { moveNextBoxFromDiary } from '../../../services/api/apiNextBoxDiary'
import ExportTrackingInfo from './export/ExportTrackingInfo'
import queryString from 'query-string'

const {Option} = Select
const {RangePicker} = DatePicker


class ListNextBoxes extends Component {
    state = {
        page: 1,
        limit: 100,
        total: 0,
        boxes: [],
        loading: false,
        error: '',
        openModal: false,
        boxId: '',
        realWeight: '',
        realHeight: '',
        realWidth: '',
        realLength: '',
        FBABox: "",
        closed_at_gte: '',
        closed_at_lt: '',
        filter: {
            boxNumber: [],
            box_name:[],
            status: ['opening', 'closed'],
        },
        allSelected: false,
        selectedItems: [],
        isOpen: false,
        isShowModal: false,
        isCreateBatchShip: false,
        SizeWeightModal: false,
        FinishUpdateInfoModal: false,
        searchValue: '',
        ship_overdue_total: 0,
        fba_pending_labelled_total: 0,
        fba_pending_labelled_filter: false,
        listShippingCarrier: [],
        allShippingCarrier: [],
        isOpenDatePicker: false,
        selectedDate: '',
        addingDiary: false,
        typeDate: ''
    }

    componentDidMount() {
        const { history } = this.props
        const { filter } = this.state
        const { location } = history
        let params = {}

        if (location.search !== '') {
            const query = queryString.parse(location.search)
            params = query
            if (!!query.status) params.status = [query.status]
        }

        this.setState({
            filter: {
                ...filter,
                ...params,
            }
        }, () => {
            this._fetchListBoxes()
        })
    }

    componentWillMount() {
        const {selectedItems} = this.state

        if (!!selectedItems && selectedItems.length > 0) {
            this.setState({
                selectedItems: [...selectedItems]
            })
        }
        // this._fetchListBoxes()
        this._fetchFiltersShippingCarrier()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {selectedItems} = this.state

        if (prevState.selectedItems.length !== selectedItems.length) {
            if (!!selectedItems && selectedItems.length > 0) {
                this.setState({
                    selectedItems: [...selectedItems]
                })
            }
        }
    }

    handleChangeFilterProp = (prop) => (value) => {
        if (prop === 'boxNumber') {
            this.setState({searchValue: ''})
            const Value = [...new Set(value.filter(i => !!i && i).map(i => i.replace(/#|'|_\d+/g, "")))]
            return this.setState({
                allSelected: false,
                selectedItems: [],
                isOpen: false,
                isOpenDatePicker: false,
                selectedDate: '',
                fba_pending_labelled_filter: false,
                filter: {
                    ...this.state.filter,
                    [prop]: Value
                },
                page: 1,
            }, this._fetchListBoxes)
        }
        return this.setState({
            allSelected: false,
            selectedItems: [],
            isOpen: false,
            isOpenDatePicker: false,
            selectedDate: '',
            fba_pending_labelled_filter: false,
            filter: {
                ...this.state.filter,
                [prop]: value
            }
        }, this._fetchListBoxes)
    }

    handleChangeTypeBox = (value) => {
        this.setState({
            allSelected: false,
            selectedItems: [],
            isOpen: false,
            isOpenDatePicker: false,
            selectedDate: '',
            fba_pending_labelled_filter: false,
            FBABox: value
        }, () => {
            this._fetchListBoxes()
        })
    }

    // Filter riêng "FBA đủ label chờ dán" (checkbox, tách khỏi dropdown trạng thái)
    onCheckFbaPendingLabelled = (e) => {
        const checked = e.target.checked
        this.setState({
            fba_pending_labelled_filter: checked,
            allSelected: false,
            selectedItems: [],
            page: 1,
            // Bật: bỏ lọc status (query fba_pending_labelled tự áp); Tắt: khôi phục status mặc định
            filter: { ...this.state.filter, status: checked ? [] : ['opening', 'closed'] },
            ...(checked && {
                FBABox: '',
                closed: '',
                closed_at_gte: '',
                closed_at_lt: '',
            }),
        }, this._fetchListBoxes)
    }

    handleSelectDate = (prop) => (date, dateString) => {

        if (prop === 'closed_at') {
            if (!!date && date.length) {
                this.setState({
                    allSelected: false,
                    selectedItems: [],
                    isOpen: false,
                    isOpenDatePicker: false,
                    selectedDate: '',
                    closed: date,
                    closed_at_gte: dateString[0],
                    closed_at_lt: dateString[1],
                }, () => {
                    this._fetchListBoxes()
                })
            } else {
                this.setState({
                    allSelected: false,
                    selectedItems: [],
                    isOpen: false,
                    isOpenDatePicker: false,
                    selectedDate: '',
                    closed: date,
                    closed_at_gte: '',
                    closed_at_lt: '',
                }, () => {
                    this._fetchListBoxes()
                })
            }
        } else {
            this.setState({
                allSelected: false,
                selectedItems: [],
                isOpen: false,
                isOpenDatePicker: false,
                selectedDate: '',
                [prop]: date,
                [`${prop}_gte`]: dateString && dateString[0],
                [`${prop}_lt`]: dateString && dateString[1],
            }, this._fetchListBoxes)
        }
    }

    getFilters = () => {
        const {
            FBABox,
            closed_at_gte,
            closed_at_lt,
            filter,
            shipped_at_gte,
            shipped_at_lt
        } = this.state
        const payload = {}

        if (FBABox === "FBA") payload.is_fba_box = true
        if (FBABox === "NOT_FBA") payload.is_fba_box = false
        if (closed_at_gte !== "") payload.closed_at_gte = closed_at_gte
        if (closed_at_lt !== "") payload.closed_at_lt = closed_at_lt
        if (filter.shipping_carrier && filter.shipping_carrier.length > 0) {
            payload.shipping_carrier = filter.shipping_carrier
        }
        if (filter.box_name && filter.box_name.length > 0) {
            payload.box_name = filter.box_name.join(', ')
        }

        if (this.state.fba_pending_labelled_filter) {
            payload.status = ['fba_pending_labelled']
        } else if (filter.status && filter.status.length > 0) {
            payload.status = filter.status
        } else {
            delete payload.status
        }
        if (!!filter.boxNumber && filter.boxNumber.length > 0) {
            payload.search = filter.boxNumber
        } else {
            delete payload.boxNumber
        }
        payload.box_partner_status = filter.box_partner_status

        if (shipped_at_gte && shipped_at_lt) {
            Object.assign(payload, {
                shipped_at: {
                    from: shipped_at_gte,
                    to: shipped_at_lt
                }
            })
        }
        if(filter.multrans_box_type) {payload.multrans_box_type = 'light'}
        if (filter.has_wood_product) payload.has_wood_product = filter.has_wood_product

        if(filter.box_meta){
            payload.box_meta = filter.box_meta
        }else{
            delete payload.box_meta
        }

        return Object.keys(payload).reduce((a, b) => {
            if (payload[b] !== undefined) {
                a[b] = payload[b]
            }

            return a
        }, {})
    }

    _fetchListBoxes = async () => {
        if (this.state.loading) return true

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {
                page,
                limit,
            } = this.state

            const payload = {
                page: page,
                limit: limit,
                ...this.getFilters()
            }

            const {success, data, message: mess} = await getListBoxes(payload)

            if (!success) {
                message.error(mess)
                throw new Error(mess)
            }

            const {boxes, ship_overdue_total, fba_pending_labelled_total, total, page: vPage, limit: vLimit} = Object.assign({}, data)

            const boxesClosed = boxes.filter(box => box.status === 'closed').sort((a, b) => {
                return new Date(a.closed_at).getTime() - new Date(b.closed_at).getTime()
            })

            localStorage.setItem('boxesClosed', JSON.stringify(boxesClosed))

            this.setState({
                loading: false,
                error: '',
                boxes: Array.isArray(boxes) ? boxes : [],
                boxesClosed: Array.isArray(boxesClosed) ? boxesClosed : [],
                total,
                page: vPage,
                limit: vLimit,
                ship_overdue_total: ship_overdue_total || 0,
                fba_pending_labelled_total: fba_pending_labelled_total || 0
            })
        } catch (e) {
            return this.setState({
                loading: false,
                error: e.message || e,
            })
        }
    }

    _handleOnChangePage = async (page) => {
        return new Promise((resolve, reject) => {
            this.setState({
                page,
                allSelected: false,
                selectedItems: [],
                isOpen: false,
                isOpenDatePicker: false,
                selectedDate: '',
            }, async () => {
                try {
                    await this._fetchListBoxes()
                    return resolve(true)
                } catch (e) {
                    return reject(e)
                }
            })
        })
    }

    _togglePopupModalEdit = () => {
        this.setState(({openModal}) => ({
            openModal: !openModal
        }))
    }

    _onGetInfoBox = (boxId, realWeight, realHeight, realWidth, realLength) => {
        this.setState({
            openModal: true,
            boxId: boxId,
            realWeight: realWeight || '',
            realHeight: realHeight || '',
            realWidth: realWidth || '',
            realLength: realLength || '',
        })
    }

    _reloadItems = () => {
        this._fetchListBoxes()
    }

    _handleOrderFullyBoxed = async (boxes) => {
        const validBoxes = boxes.filter(b => b._id != null && b.id != null)
        if (!validBoxes.length) return
        this.setState({
            selectedItems: validBoxes,
            isCreateBatchShip: true,
        })
    }

    _handleChangeSelect = (name, value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [name]: value
            },
            allSelected: false,
            selectedItems: [],
            isOpen: false,
            isOpenDatePicker: false,
            selectedDate: '',
        }, () => {
            const {filter} = this.state
            const {onChangeFilter} = this.props

            if (value === 'All') {
                delete filter[name]
            }

            delete filter['beforeId']
            delete filter['afterId']

            if (typeof this._handleChangeFilter === 'function') {
                this._handleChangeFilter(filter)
            }
        })
    }

    _handleChangeFilter = (filter) => {
        this.setState({filter: filter}, () => {
            this._fetchListBoxes()
        })
    }

    _toggleSelectAll = (e) => {
        const {checked} = e.target

        this.setState(() => {
            if (checked) {
                const {boxes} = this.state
                const itemsCanChecked = boxes.filter(item => item)

                return {
                    allSelected: true,
                    selectedItems: itemsCanChecked.map(order => order),
                    isOpen: false,
                    isOpenDatePicker: false
                }
            }

            return {
                allSelected: false,
                selectedItems: [],
                isOpen: false,
                isOpenDatePicker: false
            }
        })
    }

    _handleChangeSelected = (id, isAdded) => {
        const {selectedItems} = this.state
        const {boxes} = this.state
        const itemsCanChecked = boxes.filter(item => item)

        if (isAdded) {
            if (!selectedItems.map(i => i._id).includes(id)) {
                const newSelected = [...selectedItems, ...boxes.filter(i => i._id === id)]
                this.setState({
                    selectedItems: newSelected,
                    allSelected: newSelected.length === itemsCanChecked.length,
                    isOpen: false,
                    isOpenDatePicker: false,
                    selectedDate: ''
                })
            }
        } else {
            const filtered = selectedItems.filter(orderId => orderId._id !== id)

            this.setState({
                selectedItems: filtered,
                allSelected: filtered.length === itemsCanChecked.length,
                isOpen: false,
                isOpenDatePicker: false,
                selectedDate: ''
            })
        }
    }

    _resetBulkAll = () => {
        this.setState({
            allSelected: false,
            selectedItems: [],
            isOpen: false,
            isOpenDatePicker: false,
            selectedDate: ''
        })
    }

    _isOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen,
            isOpenDatePicker: false,
            selectedDate: ''
        })
    }

    _handleToggleModal = (keyValue) => {
        const {selectedItems, boxes} = this.state
        if (this.state[keyValue] === true) {
            this.setState({
                allSelected: selectedItems.length === boxes.length,
                isOpen: false,
                isOpenDatePicker: false,
                selectedDate: ''
            })
        }
        this.setState({
            [keyValue]: !this.state[keyValue],
            isOpenDatePicker: false,
            selectedDate: ''
        })
    }

    _handleSearchBoxNumber = (value) => {
        if (value.includes(',') || value.includes(' ')) {
            this.setState({...this.state, searchValue: ''})
            const {filter} = this.state
            const Value = [...new Set(value.replace(/ |#|'|_\d+/g, ",").split(',').map(i => i.trim()).filter(i => !!i && !filter.boxNumber.includes(i) && i))]
            this.setState({
                ...this.state,
                searchValue: '',
                filter: {
                    boxNumber: [...filter.boxNumber, ...Value]
                },
                allSelected: false,
                selectedItems: [],
                isOpen: false,
                isOpenDatePicker: false,
                selectedDate: '',
            }, this._fetchListBoxes)
        } else {
            this.setState({
                ...this.state, searchValue: value,
                allSelected: false,
                selectedItems: [],
                isOpen: false,
                isOpenDatePicker: false,
                selectedDate: '',
            })
        }
    }

    clearFilters = (hasFilters) => (e) => {
        if (!hasFilters) {
            return
        }

        const excludeProps = ['page', 'limit']
        const newState = Object.keys(this.state).reduce((a, b) => {
            return {
                ...a,
                ...(!excludeProps.includes(b) && {
                    [b]: Array.isArray(this.state[b])
                        ? []
                        : (
                            typeof this.state[b] === 'boolean'
                                ? false
                                : (
                                    typeof this.state[b] === 'number'
                                        ? 0
                                        : (
                                            typeof this.state[b] === 'object'
                                                ? {}
                                                : ''
                                        )
                                )
                        )
                })
            }
        }, {})

        this.setState(newState, this._fetchListBoxes)
    }

    onCheckMTUSNHE = (e) => {
        const { filter } = this.state
        const { checked, name } = e.target
        this.setState({
            ...this.state,
            filter: { ...filter, [name]: checked },
            allSelected: false,
            selectedItems: [],
            isOpen: false,
            isOpenDatePicker: false,
            selectedDate: '',
        }, () => {
            this._fetchListBoxes()
        })
    }

    toggleDatePicker = (type) => {
        this.setState({
            isOpenDatePicker: !this.state.isOpenDatePicker,
            selectedDate: '',
            typeDate: type,
        });
    }

    handleClickOutsideDatePicker = () => {
        this.setState({
            isOpen: false,
            isOpenDatePicker: false,
            selectedDate: '',
        });
    }

    handleSelectDateDiaryNextBoxes = (selectedDate) => {
        this.setState({selectedDate});
    }

    handleAddDiaryNextBoxes = async () => {

        this.setState({
            addingDiary: true,
            error: ''
        })

        try {
            const { selectedItems, selectedDate } = this.state
            const boxes = selectedItems.map(item => item._id)

            const payload = {
                boxes,
                date: moment(selectedDate).format("DD/MM/YYYY")
            }

            const { data: res } = await addDiaryNextBoxes(payload)
            const { success, message: mess } = { ...res }

            if (!success) {
                message.error(mess)
                throw new Error(mess)
            }

            message.success("Thêm nhật ký đóng thùng thành công.")

            this.setState({
                addingDiary: false,
                error: '',
                allSelected: false,
                selectedItems: [],
                isOpen: false,
                isOpenDatePicker: false,
                selectedDate: ''
            }, () => {
                this._fetchListBoxes()
            })

        } catch (e) {
            return this.setState({
                addingDiary: false,
                error: e.message || e,
            })
        }
    }

    handleUpdateDiaryNextBoxes = async () => {

        this.setState({
            addingDiary: true,
            error: ''
        })

        try {
            const { selectedItems, selectedDate } = this.state
            const boxes = selectedItems.map(item => item._id)

            const payload = {
                boxes,
                date: moment(selectedDate).format("DD/MM/YYYY")
            }

            const { data: res } = await moveNextBoxFromDiary(payload)
            const { success, message: mess } = { ...res }

            if (!success) {
                message.error(mess)
                throw new Error(mess)
            }

            message.success("Cập nhật ngày rời xưởng thành công.")

            this.setState({
                addingDiary: false,
                error: '',
                allSelected: false,
                selectedItems: [],
                isOpen: false,
                isOpenDatePicker: false,
                selectedDate: ''
            }, () => {
                this._fetchListBoxes()
            })

        } catch (e) {
            return this.setState({
                addingDiary: false,
                error: e.message || e,
            })
        }
    }

    _fetchFiltersShippingCarrier = async(payload) => {
        try {
            const newPayload = {
                ...payload,
                limit: 10000,
                page: 1,
            }

            const res = await getListShippingCarrierApp(newPayload)
            const {data, success, message} = {...res}
            if (!success) {
                throw new Error(message)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length>0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            }) : []
            this.setState({
                listShippingCarrier: shippingCarriers.filter(i => !!i.is_active) || [],
                allShippingCarrier: shippingCarriers || []
            })
            
        } catch (error) {
            alert(error.message)
        }
    }

    renderTitleConfirm = (type) => {
        const { selectedItems, selectedDate } = this.state
        if (type === 'select') {
            return (
                <>{`Thêm ${selectedItems.length} thùng vào nhật ký đóng thùng ngày ${moment(selectedDate).format('DD/MM/YYYY')} ?`}</>
            )
        }
        if (type === 'update') {
            return (
                <>{`Cập nhật ${selectedItems.length} thùng sang ngày rời xưởng ${moment(selectedDate).format('DD/MM/YYYY')} ?`}</>
            )
        }
    }

    disabledDate = (current) => {
        return current && current > moment().endOf('day')
    }

    render() {
        const {
            boxes, page, total, limit,
            loading, openModal, boxId,
            realWeight, realHeight, realWidth,
            realLength, closed_at_gte, closed_at_lt,
            FBABox, filter, allSelected,
            selectedItems, isOpen, isShowModal, isCreateBatchShip,
            searchValue, SizeWeightModal, FinishUpdateInfoModal: isOpenFinishUpdateInfoModal,
            ship_overdue_total, fba_pending_labelled_total, fba_pending_labelled_filter, closed,
            shipped_at, listShippingCarrier, allShippingCarrier,
            isOpenDatePicker, selectedDate, typeDate,
        } = this.state

        const { shipping_carrier, status, box_partner_status, box_meta, multrans_box_type, has_wood_product } = filter
        const hasFilters = !!Object.keys(this.getFilters()).length
        const isDisabledButtonAddDiary = !selectedDate ? true : false
        return (
            <div className="ListNextBoxes">
                <div className="HeaderPage d-flex justify-content-between">
                    <div className="d-flex align-items-start flex-wrap mb-3">

                        {/* <MarkAsShippedBox onRefresh={this._fetchListBoxes} /> */}
                        <div className='FilterMultiBox FilterDatePacking mb-2 mr-3'>
                            <Select
                                mode='tags'
                                placeholder="Tìm kiếm: Mã thùng, mã đơn FFM..."
                                allowClear
                                onChange={this.handleChangeFilterProp('boxNumber')}
                                open={false}
                                searchValue={searchValue || ''}
                                onSearch={this._handleSearchBoxNumber}
                                value={!!filter.boxNumber && !!filter.boxNumber.length ? filter.boxNumber : []}
                                className='BoxNumber'
                            >
                            </Select>
                        </div>

                        <div className='FilterBox mr-3 mb-2'>
                            <Select
                                placeholder="Loại thùng"
                                allowClear
                                onChange={this.handleChangeTypeBox}
                                className="TypeBox"
                                value={FBABox || []}
                            >
                                <Option value={"ALL"}>ALL</Option>
                                <Option value={"FBA"}>FBA</Option>
                                <Option value={"NOT_FBA"}>Not FBA</Option>
                            </Select>
                        </div>
                        <div className='FilterBox mr-3 mb-2'>
                            <Select
                                placeholder="Trạng thái"
                                allowClear
                                onChange={this.handleChangeFilterProp('status')}
                                value={status || []}
                                mode='multiple'
                                className='statusFilter'
                                style={{ maxWidth: '208px' }}
                                showSearch
                            >
                                {/* <Option value="">Tất cả</Option> */}
                                <Option value="opening">Đang mở</Option>
                                <Option value="closed">Đã đóng</Option>
                                <Option value="shipped">Đã ship</Option>
                                <Option value="ship_overdue">Đã quá hạn ship</Option>
                            </Select>
                        </div>
                        <div className='FilterBox mr-3 mb-2'>
                            <Select
                                placeholder="Trạng thái thùng"
                                allowClear
                                onChange={this.handleChangeFilterProp('box_partner_status')}
                                value={box_partner_status || []}
                            >
                                <Option value="cancel">Đã huỷ</Option>
                                <Option value="draft">Lưu nháp</Option>
                                <Option value="shipping">Đang chuyển đến US</Option>
                                <Option value="received">Đã nhận tại kho US</Option>
                                <Option value="done">Hoàn thành</Option>
                                <Option value="processing">Đang xử lý</Option>
                                <Option value="error">Lỗi</Option>
                                <Option value="">Chưa tạo thùng</Option>
                            </Select>
                        </div>
                        <div className='FilterBox mr-3 mb-2'>
                            <Select
                                placeholder="Loại thùng LLC"
                                allowClear
                                onChange={this.handleChangeFilterProp('box_meta')}
                                value={box_meta}
                            >
                                <Option value="llc.ornament">LLC Ornament</Option>
                                <Option value="llc.*">LLC khác Ornament</Option>
                            </Select>
                        </div>
                        <div className='FilterBox mr-3 mb-2'>
                            <Select
                                className='shippingCarrier FilterBox'
                                mode={'multiple'}
                                placeholder={'Chọn shipping carrier'}
                                allowClear
                                onSearch={(value) => {
                                    if (value) {
                                        const newList = allShippingCarrier.filter(i => !!i.name.toLowerCase().includes(value.toLowerCase()))
                                        this.setState({ listShippingCarrier: newList })
                                    } else {
                                        this.setState({ listShippingCarrier: allShippingCarrier.filter(i => !!i.is_active) || [] })
                                    }
                                }}
                                onBlur={() => this.setState({ listShippingCarrier: allShippingCarrier.filter(i => !!i.is_active) })}
                                filterOption={(input, option) => {
                                    return option.children.toLowerCase().includes(input.toLowerCase())
                                }}
                                style={{ width: '256px' }}
                                onChange={(value) => this._handleChangeSelect('shipping_carrier', value)}
                                value={filter.shipping_carrier || []}
                            >
                                {!!listShippingCarrier && listShippingCarrier.length > 0 &&
                                    listShippingCarrier.map((i, index) => (
                                        <Option key={index} style={!i.is_active ? {} : { color: '#333' }} value={i.slug}>{i.name}</Option>
                                    ))
                                }
                            </Select>
                        </div>
                        <div className='FilterBox mr-3 mb-2'>
                            <Select
                                className='lineship FilterBox'
                                placeholder={'Box name'}
                                allowClear
                                style={{ width: '256px' }}
                                onChange={(e) => this._handleChangeSelect('box_name',e)}
                                value={filter.box_name || []}
                                mode='tags'
                            />
                        </div>
                        <div className='FilterBox FilterDatePacking mr-3 mb-2'>
                            <RangePicker
                                className=''
                                onChange={this.handleSelectDate('closed_at')}
                                placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
                                ranges={{
                                    'Today': [moment(), moment()],
                                    'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                }}
                                format={'DD/MM/YYYY'}
                                value={closed}
                            />
                        </div>
                        <div className='FilterBox FilterDatePacking mr-3 mb-2'>
                            <RangePicker
                                className=''
                                onChange={this.handleSelectDate('shipped_at')}
                                placeholder={['Ngày ship - Từ', 'Ngày ship - Đến']}
                                ranges={{
                                    'Today': [moment(), moment()],
                                    'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                }}
                                format={'DD/MM/YYYY'}
                                value={shipped_at}
                            />
                        </div>
                        <div className="FilterBox mb-2" style={{ marginTop: '7px' }}>
                            <Checkbox
                                onChange={this.onCheckMTUSNHE}
                                checked={multrans_box_type}
                                name='multrans_box_type'
                                style={{ minWidth: '100px' }}
                            >
                                MT US nhẹ
                            </Checkbox>
                        </div>
                        <div className="FilterBox mb-2" style={{ marginTop: '7px' }}>
                            <Checkbox
                                onChange={this.onCheckMTUSNHE}
                                checked={has_wood_product}
                                name='has_wood_product'
                                style={{ minWidth: '100px' }}
                            >
                                HW SP Gỗ
                            </Checkbox>
                        </div>
                        <div className="FilterBox mb-2" style={{ marginTop: '7px' }}>
                            <Checkbox
                                onChange={this.onCheckFbaPendingLabelled}
                                checked={fba_pending_labelled_filter}
                            >
                                FBA đủ label chờ dán
                            </Checkbox>
                        </div>
                        {
                            <Tooltip title="Xóa bộ lọc">
                                <button
                                    className={["btn ml-2 mb-2 btn-reset-filter", !hasFilters && 'disabled'].filter(Boolean).join(' ')}
                                    onClick={this.clearFilters(hasFilters)}><i className="fa fa-times" />
                                </button>
                            </Tooltip>
                        }
                    </div>

                    <div className="BtnList d-flex align-items-center mb-3">
                        <CreateNewBox />
                        <CreateNewBoxFBA />
                        <ImportTrackingModal onLoadBox={this._fetchListBoxes} />
                        <ExportListBoxes
                            status={filter.status}
                            closedAtGte={closed_at_gte}
                            closedAtLt={closed_at_lt}
                            FBABox={FBABox}
                            shippingCarrier={filter.shipping_carrier || []}
                            llcStatus={filter.box_partner_status}
                            boxNumber={filter.boxNumber}
                            filter={this.getFilters()}
                        />
                        <ExportTrackingInfo
                            status={filter.status}
                            closedAtGte={closed_at_gte}
                            closedAtLt={closed_at_lt}
                            FBABox={FBABox}
                            shippingCarrier={filter.shipping_carrier || []}
                            llcStatus={filter.box_partner_status}
                            boxNumber={filter.boxNumber}
                            filter={this.getFilters()}
                        />
                        <Link to='/next-items' className="btn btn-link">Search items</Link>
                        <Link to='/next-boxes-diary' className="btn btn-link">Nhật ký đóng thùng</Link>
                    </div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="totalBox">
                        <label className='font-weight-bold'>{total}</label> {total > 1 ? 'Boxes' : 'Box'}
                    </div>
                    <div className="d-flex" style={{ gap: '24px' }}>
                        {!!ship_overdue_total &&
                            <div className="totalShipOverdue">
                                <Popover
                                    content={
                                        <label className='totalShipOverdueNote mb-0'>
                                            Chỉ tính các thùng được tạo từ 01/10/2023
                                        </label>
                                    }
                                    placement="topLeft"
                                >
                                    <label
                                        className='font-weight-bold'
                                        onClick={() => this.setState({
                                            filter: { status: ['ship_overdue'] },
                                            fba_pending_labelled_filter: false,
                                            FBABox: '',
                                            closed: '',
                                            closed_at_gte: '',
                                            closed_at_lt: '',
                                        }, this._fetchListBoxes)}
                                    >
                                        {ship_overdue_total} thùng quá hạn ship
                                    </label>
                                </Popover>
                            </div>
                        }
                        {!!fba_pending_labelled_total &&
                            <div className="totalShipOverdue">
                                <label
                                    className='font-weight-bold'
                                    style={{ cursor: 'pointer', color: '#dc3545' }}
                                    onClick={() => this.setState({
                                        fba_pending_labelled_filter: true,
                                        page: 1,
                                        allSelected: false,
                                        selectedItems: [],
                                        filter: { ...this.state.filter, status: [] },
                                        FBABox: '',
                                        closed: '',
                                        closed_at_gte: '',
                                        closed_at_lt: '',
                                    }, this._fetchListBoxes)}
                                >
                                    {fba_pending_labelled_total} thùng FBA đủ label chờ dán
                                </label>
                            </div>
                        }
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <table className="table table-striped">

                            {selectedItems.length > 0 ?
                                <thead className="TableHeadBox">
                                    <tr>
                                        <th>
                                            <Checkbox checked={allSelected} onChange={this._toggleSelectAll} />
                                        </th>
                                        <th>
                                            <div className="CustomSelect">
                                                <Button onClick={this._isOpen}
                                                    className="dropdown-toggle">Actions</Button>
                                                <div className={isOpen ? 'ListAction open' : 'ListAction'}>
                                                    <Button color="link" className="mr-1"
                                                        onClick={() => this._handleToggleModal('isShowModal')}>Tạo thùng
                                                        LLC</Button>
                                                    <BatchShipBulkAction
                                                        selectedItems={selectedItems}
                                                        onCreateBatchShip={() => this._handleToggleModal('isCreateBatchShip')}
                                                    />
                                                    <Button color="link" className="mr-1"
                                                        onClick={() => this._handleToggleModal('SizeWeightModal')}> Thêm
                                                        thông tin kích thước, cân nặng</Button>
                                                    <Button color="link" className="mr-1"
                                                        onClick={() => this._handleToggleModal('FinishUpdateInfoModal')}> Kết thúc cập nhật thông tin</Button>
                                                    <Button color="link" className="mr-1"
                                                        onClick={() => this.toggleDatePicker('select')}> Chọn ngày thực tế rời xưởng</Button>
                                                    <Button color="link" className="mr-1"
                                                        onClick={() => this.toggleDatePicker('update')}> Cập nhật ngày rời xưởng</Button>
                                                    <CreateMultiBoxLLC
                                                        visible={isShowModal}
                                                        onCancel={this._handleToggleModal}
                                                        selectedItems={selectedItems}
                                                        setSelectedItems={(i) => this.setState({ selectedItems: i })}
                                                    />
                                                    <AddSizeWeightModal
                                                        visible={SizeWeightModal}
                                                        onCancel={this._handleToggleModal}
                                                        selectedItems={selectedItems}
                                                        reload={this._fetchListBoxes}
                                                        setSelectedItems={(i) => this.setState({ selectedItems: i })}
                                                    />
                                                    <FinishUpdateInfoModal
                                                        visible={isOpenFinishUpdateInfoModal}
                                                        onCancel={this._handleToggleModal}
                                                        selectedItems={selectedItems}
                                                        reload={this._fetchListBoxes}
                                                        setSelectedItems={(i) => this.setState({ selectedItems: i, allSelected: false })}
                                                    />
                                                    <CreateBatchShip
                                                        isOpen={isCreateBatchShip}
                                                        onCancel={this._handleToggleModal}
                                                        selectedItems={selectedItems || []}
                                                        reload={this._fetchListBoxes}
                                                        setSelectedItems={() => this.setState({ selectedItems: [] })}
                                                    />

                                                    <div className='DiaryNextBoxesSelectDate'>
                                                        {
                                                            isOpenDatePicker &&
                                                            <div className='DiaryNextBoxesSelectDateOverlay' onClick={() => this.handleClickOutsideDatePicker()}></div>
                                                        }

                                                        <DatePicker
                                                            className="mcHiddenInput"
                                                            open={isOpenDatePicker}
                                                            onChange={this.handleSelectDateDiaryNextBoxes}
                                                            value={selectedDate !== "" ? selectedDate : null}
                                                            // disabledDate={this.disabledDate}
                                                            renderExtraFooter={() => {
                                                                return (
                                                                    typeDate === 'select' ?
                                                                        <Popconfirm
                                                                            title={this.renderTitleConfirm('select')}
                                                                            onConfirm={this.handleAddDiaryNextBoxes}
                                                                            onCancel={this.toggleDatePicker}
                                                                            okText="Yes"
                                                                            cancelText="No"
                                                                            disabled={isDisabledButtonAddDiary}
                                                                        >
                                                                            <Button type="primary" size="large" disabled={isDisabledButtonAddDiary}>
                                                                                Add
                                                                            </Button>
                                                                        </Popconfirm> :
                                                                        typeDate === 'update' ?
                                                                            <Popconfirm
                                                                                title={this.renderTitleConfirm('update')}
                                                                                onConfirm={this.handleUpdateDiaryNextBoxes}
                                                                                onCancel={this.toggleDatePicker}
                                                                                okText="Yes"
                                                                                cancelText="No"
                                                                                disabled={isDisabledButtonAddDiary}
                                                                            >
                                                                                <Button type="primary" size="large" disabled={isDisabledButtonAddDiary}>
                                                                                    Update
                                                                                </Button>
                                                                            </Popconfirm> : false
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </th>
                                        <th colSpan={12}>
                                            <strong>{selectedItems.length} {selectedItems.length !== 1 ? 'items' : 'item'} selected</strong>
                                        </th>
                                    </tr>
                                </thead>
                                : <TableHeadBox allSelected={allSelected} toggleSelectAll={this._toggleSelectAll} />
                            }
                            {isOpen && <div className="Background" onClick={this._isOpen}/>}
                            {
                                !loading && <BoxItemContainer
                                    boxes={boxes}
                                    onGetInfoBox={this._onGetInfoBox}
                                    selectedItems={selectedItems}
                                    onChangeSelected={this._handleChangeSelected}
                                    handleChangeSelect={this._handleChangeSelect}
                                />
                            }
                        </table>

                        {
                            loading ? <Spin spinning={loading} tip='Đang tải...' className='next-boxes-loading'/> : ''
                        }

                        {
                            !loading && (total > limit) && <ListBoxPagination
                                page={page}
                                limit={limit}
                                total={total}
                                loading={loading}
                                onChange={this._handleOnChangePage}
                            />
                        }
                    </div>
                </div>

                <ModalEditInfoBox
                    boxes={boxes}
                    boxId={boxId}
                    realWeight={realWeight}
                    realHeight={realHeight}
                    realWidth={realWidth}
                    realLength={realLength}
                    isOpen={openModal}
                    className="EditInfoBox"
                    onToggleModal={this._togglePopupModalEdit}
                    onReloadBox={this._reloadItems}
                    onOrderFullyBoxed={this._handleOrderFullyBoxed}
                />
            </div>
        )
    }
}

export default ListNextBoxes
